import React, { FC } from 'react';
import ReactDOM from 'react-dom';

interface PortalProps {
  children: React.ReactNode
  where: HTMLElement
}

export const Portal: FC<PortalProps> = ({ where, children }) => {
  return ReactDOM.createPortal(children, where);
};
